(function () {
    'use strict';

    var $ = window.jQuery;

    function Header(options) {
        var self = this;
        this.options = $.extend({}, Header.defaults, options);
        this.initStickyHeader();
        this.initMenu();
        this.initMobileMenu();

        var resizeTimer;

        $(window).resize(function () {
            resizeTimer && clearTimeout(resizeTimer);
            resizeTimer = setTimeout(self.initMenu, 100);
        });
    }

    Header.prototype.initStickyHeader = function () {
        if (true !== this.options.stickyHeader) {
            return;
        }
        var $headerSelector = $(this.options.navContainer),
            $subheaderSelector = $(this.options.secondaryContainer),
            $mobileSubheaderSelector = $(this.options.homeSecondaryContainer);

        if ($headerSelector.length) {
            // Sticky Header
            new Waypoint.Sticky({
                element: $headerSelector[0],
                stuckClass: 'fixed'
            });
        }

        if ($subheaderSelector.length) {
            // Sticky subHeader
            new Waypoint.Sticky({
                element: $subheaderSelector[0],
                stuckClass: 'fixed',
                offset: $headerSelector.innerHeight()
            });
        }

        if ($mobileSubheaderSelector.length) {
            // Sticky subHeader
            new Waypoint.Sticky({
                element: $mobileSubheaderSelector[0],
                stuckClass: 'fixed',
                wrapper: '<div class="sticky-wrapper hide-on-desktop" />',
                offset: $headerSelector.innerHeight()
            });
        }
    };

    Header.prototype.initMenu = function () {
        console.log('init menu');

        var $dropdown = $('.nav li.dropdown'),
            $navbarToggle = $('.navbar-toggle');

        //Reset events and options
        $dropdown.find('> a').off('click');
        $dropdown.off('click');
        $dropdown.off('mouseenter');
        $dropdown.off('mouseleave');
        // $navbarToggle.off('click');
        $dropdown.removeClass('open')
            .find('.dropdown-menu')
            .stop()
            .hide();

        //Disable event for the main url in the menu.
        $dropdown.find('>a').on('click', function (e) {
            e.preventDefault();
        });


        //Default menu events
        $dropdown.on('click', function () {
            console.log('dropdown click');

            var $element = $(this);

            //close other menu's
            $dropdown
                .not($element)
                .removeClass('open')
                .find('dropdown-menu')
                .stop()
                .slideDown(200);

            //if this menu already opened - close it.
            if ($element.hasClass('open')) {
                $element.removeClass('open')
                    .find('.dropdown-menu')
                    .stop()
                    .slideUp(200);
            } else {
                $element.addClass('open')
                    .find('.dropdown-menu')
                    .stop()
                    .slideDown(200);
            }
        });

        //Window size specified events
        if ($(window).width() > 1240) {
            console.log('desktop menu');

            $dropdown.on('mouseenter', function () {
                console.log('enter');
                if (!$(this).hasClass('open')) {
                    $(this).trigger('click');
                }
            });

            $dropdown.on('mouseleave', function () {
                console.log('leave');
                if ($(this).hasClass('open')) {
                    $(this).trigger('click');
                }
            });
        } else {
            console.log('mobile menu');

            $(document).on('mobile_menu.opened', function () {
                console.log('opened');
                $dropdown
                    .first()
                    .addClass('open')
                    .find('.dropdown-menu')
                    .stop()
                    .slideDown(200);
            });

            $(document).on('mobile_menu.closing', function () {
                console.log('closing');
                $dropdown.removeClass('open')
                    .find('.dropdown-menu')
                    .stop()
                    .slideUp(200);
            });
        }
    };

    Header.prototype.initMobileMenu = function () {
        const $headerNavSelector = document.querySelector('.podcasts-archive__header .menu'),
            $mobileHamburger = document.querySelector('.podcasts-archive__header .menu .hamb');

        if($mobileHamburger) {
            $mobileHamburger.addEventListener('click',function (e) {
                e.preventDefault();

                var target = e.target;

                target.classList.toggle('open');

                if ($headerNavSelector.classList.contains('opened')) {
                    $headerNavSelector.classList.remove('opened');
                } else {
                    $headerNavSelector.classList.add('opened');
                }
            });
        }
    };

    Header.defaults = {
        navContainer: 'nav.navbar-bordeaux',
        secondaryContainer: '.subnav',
        homeSecondaryContainer: '.mobile_subnav',
        stickyHeader: true
    };

    window.Header = Header;

})();
